import React, { useState, useEffect, useCallback } from 'react';
import IncomingCallModal from '@medflex/components/stories/IncomingCallModal/IncomingCallModal';
import { TRACKING_ACTIONS, trackEvent } from '@medflex/utils/Tracking';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import { CALL_RINGING_TONE_TIMEOUT } from '../constants';
import useSessionCalls from '../hooks/useSessionCalls';

const IncomingCallModule = () => {
  const isWideScreen = useIsWideScreen();
  const [showIncomingCall, setShowIncomingCall] = useState(false);
  const { incoming, cancel, goTo } = useSessionCalls();
  const [caller, setCaller] = useState(null);
  const [ringTimeout, setRingTimeout] = useState();

  useEffect(() => {
    clearTimeout(ringTimeout);
    if (incoming) {
      const timeout = setTimeout(() => setShowIncomingCall(false), CALL_RINGING_TONE_TIMEOUT);
      setRingTimeout(timeout);

      const { userId, initials, avatar, ...user } = incoming.participants.find(
        participant => participant.roles && participant.roles.includes('moderator'),
      );

      setCaller({
        fullNameWithTitle: getFullNameWithTitle({ id: userId, ...user }),
        initials,
        ...(avatar && { avatar }),
      });

      setShowIncomingCall(true);
    } else {
      setShowIncomingCall(false);
    }
  }, [incoming]);

  const acceptCall = useCallback(() => {
    trackEvent({
      zone: 'Session Call',
      action: TRACKING_ACTIONS.CLICK,
      actionText: 'accepted',
    });
    setShowIncomingCall(false);
    goTo({ id: incoming.id });
  }, [incoming]);

  const denyCall = () => {
    trackEvent({
      zone: 'Session Call',
      action: TRACKING_ACTIONS.CLICK,
      actionText: 'denied',
    });
    cancel({ id: incoming.id });
    setShowIncomingCall(false);
  };

  if (showIncomingCall && caller) {
    return (
      <IncomingCallModal
        onClickAccept={acceptCall}
        onClickDeny={denyCall}
        name={caller.fullNameWithTitle}
        initials={caller.initials}
        avatarSrc={caller.avatar}
        showCloseButton={isWideScreen}
      />
    );
  }
  return null;
};

export default IncomingCallModule;
